var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33568",
    "data-name": "Group 33568",
    transform: "translate(18586 21844)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9771",
    "data-name": "Rectangle 9771",
    width: 24,
    height: 24,
    transform: "translate(-18586 -21844)",
    fill: "#808080",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_60_214",
    "data-name": "Component 60 \\u2013 214",
    transform: "translate(-18582.105 -21842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9770",
    "data-name": "Rectangle 9770",
    width: 1.351,
    height: 20,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M8.172,12.631A2.229,2.229,0,0,1,5.945,10.4V9.658H0V1.486H7.432a.741.741,0,0,1,.74.74.741.741,0,0,0-.74-.74H0V0H7.432A2.228,2.228,0,0,1,9.658,2.227v.746h6.688v9.658Zm-.74-2.23a.742.742,0,0,0,.74.744h6.691v0H8.172A.742.742,0,0,1,7.432,10.4Z",
    transform: "translate(1.352 0.002)",
    fill: "#808080",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDisabled);
export default __webpack_public_path__ + "static/media/flag-disabled.51d953ee8cebe928e8eaeb2042b34e7d.svg";
export { ForwardRef as ReactComponent };